import { customElement } from 'lit/decorators.js';
import { TuftsYext } from '../tufts-yext/tufts-yext';
import { CSSResultGroup, TemplateResult, html } from 'lit';
import StyleTuftsYext from '../tufts-yext/tufts-yext.css.lit';

import componentStyles from './tufts-yext-researchers.css.lit';
import { HealthcareProfessional } from '../tufts-yext/tufts-yext-types';

/**
 * The Yext Researchers component.
 * @element tufts-yext-researchers
 */

@customElement('tufts-yext-researchers')
export class TuftsYextResearchers extends TuftsYext {
  static styles: CSSResultGroup = [StyleTuftsYext, componentStyles];

  verticalKey = 'researchers';

  // Add researcher-specific facet display names
  protected override facetDisplayNames: { [key: string]: string } = {
    c_researchInstitute: 'Research Institute',
    c_researchGroupsAndCenters: 'Research Groups + Centers',
    c_specialtyName: 'Research by Specialty',
  };

  searchAuxiliaryTextTemplate() {
    return html``;
  }

  redirectionProfileDebug(data: HealthcareProfessional): string {
    if (this.debug) {
      return `/?path=/story/content-yext-yext-item--tufts-yext-item&yext=${data.c_url_id}`;
    } else {
      return `/researcher/${data.c_url_id}`;
    }
  }

  headingAndBreadcrumbsTemplate(): TemplateResult {
    return html` <tufts-breadcrumbs>
        <nav class="breadcrumb">
          <ol slot="breadcrumb">
            <li>
              <a href="/">Home</a>
            </li>
          </ol>
        </nav>
      </tufts-breadcrumbs>
      <tufts-heading level-size="xxl">
        <h1>Find a Researcher</h1>
      </tufts-heading>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-yext-researchers': TuftsYextResearchers;
  }
}
